export default __webpack_public_path__ + "static/media/logo_GMX_org.17e8891c.svg";